import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2x8iq90jfihc1 as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.n4l_1.x4g($this.m4l_1.j4j());
  $this.o4l_1 = add($this.o4l_1, appended);
}
function updateConsumed($this) {
  $this.p4l_1 = add($this.p4l_1, subtract($this.o4l_1, $this.n4l_1.q2()));
  $this.o4l_1 = $this.n4l_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.m4l_1 = delegate;
        this.n4l_1 = new (Buffer())();
        this.o4l_1 = 0n;
        this.p4l_1 = 0n;
      }
      q4l() {
        updateConsumed(this);
        return this.p4l_1;
      }
      w4j() {
        return this.m4l_1.w4j();
      }
      b4k() {
        return this.n4l_1.v3v() && this.m4l_1.b4k();
      }
      j4j() {
        transferFromDelegate(this);
        return this.n4l_1;
      }
      *c4k(min, $completion) {
        if (this.j4j().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.m4l_1.c4k(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      m4k(cause) {
        this.m4l_1.m4k(cause);
        this.n4l_1.l6();
      }
    }
    protoOf($).i4k = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
